import { render, staticRenderFns } from "./downloaddocument.vue?vue&type=template&id=456af6a8&scoped=true"
import script from "./downloaddocument.vue?vue&type=script&lang=js"
export * from "./downloaddocument.vue?vue&type=script&lang=js"
import style0 from "./downloaddocument.vue?vue&type=style&index=0&id=456af6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456af6a8",
  null
  
)

export default component.exports